import { render, staticRenderFns } from "./TextAreaRenderer.vue?vue&type=template&id=1610ccd2&scoped=true&"
import script from "./TextAreaRenderer.vue?vue&type=script&lang=js&"
export * from "./TextAreaRenderer.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaRenderer.vue?vue&type=style&index=0&id=1610ccd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610ccd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1610ccd2')) {
      api.createRecord('1610ccd2', component.options)
    } else {
      api.reload('1610ccd2', component.options)
    }
    module.hot.accept("./TextAreaRenderer.vue?vue&type=template&id=1610ccd2&scoped=true&", function () {
      api.rerender('1610ccd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/form_renderers/TextAreaRenderer.vue"
export default component.exports